import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";

// Reemplaza esto con tus credenciales de la Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyA8lr2MfwmBWK16DFincqcL_8IcoV6o4Cw",
  // El dominio propio (servido por Firebase Hosting, que expone /__/auth/handler) hace que
  // el login con Google sea del mismo origen; con firebaseapp.com la TWA de Android pierde
  // el resultado por el particionado de almacenamiento de Chrome.
  authDomain: "gexvi.com",
  databaseURL: "https://sky-red-social-default-rtdb.firebaseio.com",
  projectId: "sky-red-social",
  storageBucket: "sky-red-social.firebasestorage.app",
  messagingSenderId: "999069844196",
  appId: "1:999069844196:web:1e50b7035f9a26ecf262f1",
  measurementId: "G-V0QKB6EGH8",
};

const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA Enterprise). La clave solo acepta gexvi.com y los dominios de
// Firebase del proyecto, así que en local se usa un token de depuración (se imprime en la
// consola del navegador y hay que registrarlo en Firebase Console > App Check > Administrar
// tokens de depuración).
if (process.env.NODE_ENV !== "production") {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}
initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider("6Ldw_fstAAAAAPW2NDxrB_Lgf4-b0bdAi-tGYWm-"),
  isTokenAutoRefreshEnabled: true,
});

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// getAnalytics() falla en navegadores/contextos sin soporte (Safari privado,
// bloqueadores de contenido, etc.), por eso se inicializa solo si isSupported()
// lo confirma. `analytics` queda en null hasta que la promesa resuelve.
let analytics = null;
isSupported()
  .then((supported) => {
    if (supported) analytics = getAnalytics(app);
  })
  .catch(() => {});

export { db, auth, storage, functions, analytics };